<script>
import TagsList from "@/system/components/global/tags/TagsList";

export default {
    components: {
        TagsList,
    },

    props: ['event', 'fullDescription', 'is_waiting_list_enabled'],

    computed: {
        eventDescription () {
            if (this.fullDescription) {
                return this.event.notes_formatted;
            } else {
                return this.$filters.truncate(this.event.notes_formatted, 150);
            }
        },

        canJoinEvent() {
            return !this.event.client_is_subscribed
                && !this.event.is_filled
                && this.event.is_open
                && !this.fullDescription;
        },

        canJoinWaitingList() {
            return this.event.waiting_list_enabled
                && this.is_waiting_list_enabled
                && this.event.is_filled
                && this.event.is_open
                && !this.event.client_is_subscribed
                && !this.fullDescription;
        },

        isMultidayEvent() {
            const start = moment(this.event.start);
            const end = moment(this.event.end);
            return !start.isSame(end, 'day');
        },

        canBook() {
            if (this.canJoinEvent || this.canJoinWaitingList) {
                return true;
            }
            return false;
        }
    }
}
</script>


<template>
    <router-link :is="canBook ? 'router-link' : 'div'" :to="'/event/' + event.slug" class="event-card-wrapper">
        <div class=" grey-text event-card" :class="{'no-spaces': event.is_filled || !event.is_open}">
            <div class="event-attending" v-if="event.client_is_subscribed">
                <i class="zmdi zmdi-check"></i>
                {{ trans('events.already_subscribed_label') }}
            </div>
            <div class="event-attending" v-if="event.client_is_waiting_list">
                <i class="zmdi zmdi-check"></i>
                {{ trans('events.already_waiting_list_label') }}
            </div>
            <div
                class="events-img"
                :class="event.has_image ? 'has-image' : 'p-0'"
                :style="{backgroundImage: 'url(' + event.image_url + ')'}">
            </div>
            <div class="events-content-container">
                <div class="flex flex-col justify-between flex-1 p-6">
                    <div class="event-content">
                        <div class="event-date gap-6">

                            <div class="event-dates">
                                <div class="event-day-month n-color-text-weak">
                                    <div class="event-day">{{ $filters.humanize_day(event.start)}}</div>
                                    <div class="event-month">{{ $filters.humanize_month_short(event.start) }}</div>
                                </div>

                                <span v-if="isMultidayEvent" class="event-date-spacer n-color-text-weak">—</span>

                                <div class="event-day-month n-color-text-weak" v-if="isMultidayEvent">
                                    <div class="event-day">{{ $filters.humanize_day(event.end)}}</div>
                                    <div class="event-month">{{ $filters.humanize_month_short(event.end) }}</div>
                                </div>
                            </div>

                            <div class="event-times n-color-text-weak leading-relaxed">
                                <span :class="{'block': !isMultidayEvent}">{{ $filters.humanize_day_of_week(event.start) }}</span>
                                <span class="event-time">{{ $filters.lowercase($filters.humanize_time(event.start)) }}</span>
                                <span v-if="!isMultidayEvent">
                                    - <span class="event-time">{{ $filters.lowercase($filters.humanize_time(event.end)) }}</span>
                                </span>
                                <span class="event-end" v-else>
                                    <span>{{ $filters.humanize_day_of_week(event.end) }}</span>
                                    <span class="event-time">{{ $filters.lowercase($filters.humanize_time(event.end)) }} </span>
                                </span>
                            </div>
                        </div>

                        <h3 class="event-title n-color-text" >{{ event.name }}</h3>

                        <div class="event-course n-color-text" v-for="practitioner in event.practitioners" :key="practitioner.id">{{ practitioner.realname }}</div>
                        <p class="mb-0 n-color-text-weak" v-if="event.notes_formatted" v-sanitize-html="eventDescription"></p>

                        <tags-list :tags="event.tags" theme="client-universe" class="event-tags mb-5" />
                    </div>

                    <button v-if="canJoinEvent" class="btn btn-custom btn-lg rounded-md mt-6" type="button">
                        {{ trans('online_booking.join_event') }}
                    </button>
                    <button v-else-if="canJoinWaitingList" class="btn btn-trans text-brand-primary btn-lg font-bold rounded-md mt-6" type="button">
                        {{ trans('waiting_list.event_join') }}
                    </button>
                    <button v-else-if="!fullDescription" class="btn btn-trans btn-lg font-bold rounded-md mt-6 n-color-text" disabled>
                        {{ event.is_filled ? trans('online_booking.fully_booked') : trans('online_booking.event_closed') }}
                    </button>
                </div>
                <div class="event-footer">
                    <div class="event-price n-color-text" v-if="event.price">
                        {{ event.price_formatted_with_vat }}
                    </div>

                    <div class="event-spots n-color-text" v-if="!event.hide_spots && event.is_open">
                        <span v-if="event.available_spots == 1">
                            <span>{{ event.available_spots }}</span>
                            {{ trans('events.spot_left') }}
                        </span>
                        <span v-else>{{ event.available_spots }} {{ trans('events.spots_left') }}</span>
                    </div>
                    <div class="event-address n-color-text" v-if="event.address || event.city || event.zip">
                        <a target="_blank" :href="'http://maps.google.com/?q=' + event.address + ',' + event.zip + ',' + event.city" style="color: #797979;">
                            <span v-if="event.address">{{ event.address }}<span v-if="event.city || event.zip">, </span></span>
                            <span v-if="event.zip">{{ event.zip }}<span v-if="event.city">, </span></span>
                            <span v-if="event.city">{{ event.city }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </router-link>
</template>
